import React from 'react';

import { IconButton, makeStyles } from '@material-ui/core';
import Close from '@material-ui/icons/Close';

const useStyles = makeStyles({
  wrapper: {
    zIndex: 999,
    margin: 'auto',
  },
});

export default function ClearButton({ onClick, withMargin = false, ...props }) {
  const classes = useStyles();
  return (
    <div className={classes.wrapper} style={{ marginRight: withMargin ? 6 : 0 }} {...props}>
      <IconButton size="small" onClick={onClick}>
        <Close />
      </IconButton>
    </div>
  );
}
